import React, {useEffect} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';

import ContentsHeader from '../../../layouts/ContentsHeader';
import Layout from '../../../layouts';

const PaymentFailed = () => {
  const [searchParams] = useSearchParams();
  const navigator = useNavigate();
  const localStorageKey = 'WEB_PAYMENT_INFO';
  useEffect(() => {
    localStorage.removeItem(localStorageKey);
  }, []);
  return (
    <Layout.Main>
      <div style={{position: 'relative'}}>
        <ContentsHeader
          txt={'결제하기'}
          isOption={'none'}
          isBottomLine={''}
          back={() => navigator('/home')}
        />
        <h1>결제 실패</h1>
        <div>{`사유: ${searchParams.get('message')}`}</div>
      </div>
    </Layout.Main>
  );
};

export default PaymentFailed;
